import { Component, EventEmitter, Input, Output } from '@angular/core';

import { DateUtils } from '@shared/date-utils';
import { AcompanhamentoPedagogicoRegistro } from '../models/acompanhamento-pedagogico.types';

@Component({
  selector: 'app-acompanhamento-list',
  templateUrl: './acompanhamento-list.component.html',
  styleUrls: ['./acompanhamento-list.component.scss']
})
export class AcompanhamentoListComponent {
  @Input() registros: AcompanhamentoPedagogicoRegistro[] = [];
  @Input() carregando = false;
  @Input() possuiPeriodos = false;

  @Output() editar = new EventEmitter<AcompanhamentoPedagogicoRegistro>();
  @Output() excluir = new EventEmitter<AcompanhamentoPedagogicoRegistro>();
  @Output() togglePublicacao = new EventEmitter<AcompanhamentoPedagogicoRegistro>();

  formatarData(data: string): string {
    return DateUtils.formatarDataBrasileira(data);
  }

  trackByRegistro(_index: number, registro: AcompanhamentoPedagogicoRegistro): number {
    return registro.id;
  }
}